import InstagramIcon from "../../assets/svgs/SocialMedia/Instagram.svg"
import LinkedinIcon from '../../assets/svgs/SocialMedia/Linkedin.svg'

const Social = () => {
    const socialContent = [
      { id: 1, liveLink: "https://www.linkedin.com/company/yolocoliving/mycompany/verification/", icon: LinkedinIcon },
      { id: 2, liveLink: "https://www.instagram.com/yolocoliving/", icon: InstagramIcon },
    ];
    return (
      <>
        {socialContent.map((item) => (
          <li className="list-inline-item" key={item.id}>
            <a href={item.liveLink} target="" rel="noopener noreferrer">
              <img className="width_40" src={item.icon} alt="Imagem da Rede Social" ></img>
            </a>
          </li>
        ))}
      </>
    );
  };
  
  export default Social;
